module.exports = __webpack_public_path__ + "img/hero-bg.57ef3a6e.jpg";